export default __webpack_public_path__ + "media/images/86-3e88424d69f712a466e5a0bed3057c4e.jpg";